function breakpoint(breakpoint)
{
  let breakpoints = {
    'xs': 0,
    'sm': 576,
    'md': 768,
    'lg': 992,
    'xl': 1200,
    'xxl': 2000,
    'screenW': $(window).width(),
    'screenH': $(window).height(),
  }
  return breakpoints[breakpoint]
}

function breakpointUp(value)
{
  if (value === '') return true;
  return breakpoint('screenW') >= breakpoint(value)
}

function breakpointDown(value)
{
  if (value === '') return true;
  return breakpoint('screenW') < breakpoint(value)
}

function screenSizeCoefficient()
{
  let coefficient = 1
  if (breakpoint('screenW') > breakpoint('hd')) {
    coefficient = breakpoint('screenW') /  breakpoint('hd')
  }

  coefficient = coefficient < 0.7 ? 0.7 : coefficient

  return coefficient
}

export { breakpoint, screenSizeCoefficient, breakpointUp, breakpointDown }
